module.exports = __webpack_public_path__ + "static/media/bytt-no-16.27e791f6.mp3";